import type { WithActiveBranchId } from '@app/api/shared';

export enum ClientCommentsEndpoints {
  AddClientComment = 'AddClientComment',
  EditClientComment = 'EditClientComment',
  DeleteClientComment = 'DeleteClientComment',
  UnpinClientComment = 'UnpinClientComment',
}

export interface ModelClientComment {
  ClientId: number;
  Comment: string | null;
}

export type AddClientCommentRequest = WithActiveBranchId<{
  data: ModelClientComment;
}>;

export type EditClientCommentRequest = WithActiveBranchId<{
  commentId?: number;
  text?: string;
}>;

export type DeleteClientCommentRequest = WithActiveBranchId<{
  commentId?: number;
}>;

export type UnpinClientCommentRequest = WithActiveBranchId<{
  commentId: number;
}>;

export type AddClientCommentResponse = void;
export type EditClientCommentResponse = void;
export type DeleteClientCommentResponse = void;
export type UnpinClientCommentResponse = void;
